<template>
    <div>
        <div
            class="flex overflow-hidden relative"
            style="width: 1920px; height: 1080px;transform: scale(0.666666667); transform-origin: 0 0"
            :class="steps"
            v-if="one"
        >
            <video width="1920" height="1080" autoplay muted loop class="bg-video">
                <source src="/video3.mp4" type="video/mp4" />
            </video>
            <div class="logo-versus">
                <img src="https://versus.com/img/versus.svg" />
            </div>
            <device ref="one" :winner="one.score >= two.score" :device="one" position="left" :vector="vector" />
            <div class="line">
                <div class="circle">
                    <span>VS</span>
                </div>

                <portal-target name="step"></portal-target>
            </div>
            <device ref="two" :winner="two.score > one.score" :device="two" position="right" :vector="vector" />
            <portal-target name="stats"></portal-target>

            <div class="last-step-content">
                <div>
                    <h3>Find out more on versus.com</h3>
                    <img src="https://versus.com/img/versus.svg" />
                </div>
                <div>
                    <h3>Produced by</h3>
                    <img src="/upvideo.svg" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { wait } from "../utils";
import Device from "../components/Device";

export default {
    name: "Home",
    components: { Device },
    head: {
        title: {
            inner: "Videos"
        }
    },
    data() {
        return {
            steps: ["step1"],
            one: null,
            two: null,
            vector: null
        };
    },

    async created() {
        const urlParams = new URLSearchParams(window.location.search);
        const device = urlParams.get("device");

        const url = device
            ? device.indexOf("192.168") >= 0
                ? device
                : `https://cors-anywhere.herokuapp.com/${device}`
            : "http://192.168.1.232:9000/storage/data/devices/62c55a820e02d76b5f1902c316fd090c.json";
        const response = await fetch(url);
        const json = await response.json();

        this.one = json.one;
        this.two = json.two;
        this.vector = json.vector;

        if (urlParams.get("dev")) {
            this.start();
        }
        window.start = () => {
            this.start();
        };
    },
    methods: {
        async start() {
            await wait(1000);
            this.steps.push("step2");
            await wait(3500);
            this.steps.push("step3");

            this.$refs.one.start();
            this.$refs.two.start();
        },

        async end() {
            this.steps.push("last-step");
            await wait(3500);

            eval(`
                console.log("ending!!");
                const { ipcRenderer } = require("electron");
                ipcRenderer.send("end");
            `);
        }
    }
};
</script>
<style>
html,
body {
    overflow: hidden;
}
.bg-video {
    position: absolute;
    z-index: 5;
    filter: grayscale(100);
    mix-blend-mode: multiply;
    opacity: 0.2;
    pointer-events: none;
}

.logo-versus {
    position: absolute;
    height: 40px;
    left: 40px;
    top: 40px;
    opacity: 0.6;
    z-index: 20;
}
.logo-versus img {
    height: 100%;
}

.line {
    width: 10px;
    position: relative;
    z-index: 10;
    background: #fff;
}
.line .circle {
    background: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 145px;
    height: 145px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
}
.line .circle span {
    font-size: 60px;
    font-weight: 900;
    font-style: italic;
    background: -webkit-linear-gradient(left, #FFCD00, #39C3E0);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
.line .badge {
    background: #fff;
    position: absolute;
    width: auto;
    height: auto;
    border-radius: 200px;
    top: 80px;
    left: 50%;
    transform: translate(-50%, 0);
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    text-align: center;
}
.line .badge span {
    padding: 10px 40px;
    font-size: 50px;
    font-weight: 900;
    font-style: italic;
    background: -webkit-linear-gradient(left, #FFCD00, #39C3E0);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
.device-content {
    position: relative;
    text-shadow: 0 0 6px rgba(0, 0, 0, 0.7)
}
.device-content--left {
    background-image: linear-gradient(#FFCD00, #FFCD00);
}
.device-content--right {
    background-image: linear-gradient(#39C3E0, #39C3E0);
}
.device-content--right .bars .bar-content__title,
.device-content--right .bars .bar-content .bar {
    flex-direction: row-reverse;
}
.device-content .device {
    height: 1400px;
    position: absolute;
    top: 170px;
    mix-blend-mode: multiply;
    filter: grayscale(100);
    opacity: 0.6;
    z-index: 20;
}
.device-content .device--left {
    left: 50%;
    transform: translateX(-50%);
}
.device-content .device--right {
    right: 50%;
    transform: translateX(50%);
}
.device-content .title {
    color: #fff;
    text-shadow: 0 0 6px rgba(0, 0, 0, 0.7);
    text-align: center;
    font-size: 60px;
    font-weight: 800;
    position: absolute;
    z-index: 20;
    top: 50%;
    left: 0;
    right: 0;
    transform: translateY(-50%);
}
.device-content .title span {
    display: block;
    font-size: 70px;
    font-weight: 300;
}
.device-content .bars {
    position: absolute;
    left: 100px;
    right: 100px;
    top: 300px;
    bottom: 100px;
    z-index: 20;
    transition: all 0.3s;
    transition-delay: 0.5s;
}
.device-content .bar-content {
    margin-bottom: 60px;
}

.device-content .bar-content:nth-child(2) {
    transition-delay: 1s;
}
.device-content .bar-content:nth-child(3) {
    transition-delay: 1.5s;
}
.device-content .bar-content:nth-child(4) {
    transition-delay: 2s;
}
.device-content .bar-content:nth-child(5) {
    transition-delay: 2.5s;
}

.device-content .bar-content__title,
.device-content .bar-content__title {
    display: flex;
    color: #fff;
    align-items: center;
    justify-content: space-between;
}
.device-content .bars .bar-content__title h2 {
    font-size: 30px;
    text-transform: uppercase;
    margin: 0;
    text-align: left;
}
.device-content.device-content--right .bars .bar-content__title h2 {
     text-align: right;
 }
.device-content .bars .bar-content__title h3 {
    font-size: 30px;
    font-weight: 400;
    margin: 0;
}
.device-content .bars .bar-content .bar {
    height: 19px;
    background: #fff;
    border-radius: 20px;
    margin-top: 20px;
    display: flex;
    padding: 3px;
}

.device-content .bars .bar-content .bar span {
    display: block;
    background: linear-gradient(0deg, #00feb0, #39c3e0);
    border-radius: 20px;
}
.last-step .svg-container {
    opacity: 0;
}
.last-step-content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 20;
    pointer-events: none;
}
.last-step-content div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 60px;
    opacity: 0;
    transition: all 0.3s;
    transition-delay: 0.5s;
}
.last-step-content div h3 {
    font-weight: bold;
    margin: 0;
    color: #fff;
    font-size: 40px;
    margin-bottom: 40px;
}
.last-step-content div img {
    height: 80px;
}
.last-step-content div:last-child {
    transition-delay: 1s;
}
.last-step-content div:last-child h3 {
    margin-bottom: 20px;
}
.last-step-content div:last-child img {
    height: 110px;
    margin-top: 10px;
    margin-bottom: -20px;
}
.step1 .device-content--left {
    flex: 1;
}
.step1 .device-content .title {
    opacity: 0;
    transform: scale(1.5) translateY(-50%);
    transition: all 0.3s;
    transition-delay: 1.2s;
}
.step1 .device-content .device {
    opacity: 0;
    transition: all 0.5s ease-in-out;
    transition-delay: 0.5s;
}
.step1 .device-content .device--left {
    left: -50%;
}
.step1 .device-content .device--right {
    right: -50%;
}
.step1 .line {
    opacity: 0;
    margin-right: -10px;
    transition: all 0.3s;
}
.step1 .line .circle {
    opacity: 0;
    transform: rotate(45deg) translate(-50%, -50%);
    transform-origin: 0 0;
    transition: all 0.3s;
    transition-delay: 0.5s;
}
.step1 .logo-versus {
    opacity: 1;
    height: 80px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: all 0.3s;
}

.step1.step2 .logo-versus {
    position: absolute;
    height: 40px;
    left: 40px;
    top: 40px;
    opacity: 0.6;
    z-index: 20;
    transform: translate(0);
}
.step1.step2 .device-content--right {
    animation: device-content 0.3s forwards;
}
@keyframes device-content {
    0% {
        flex: 0;
    }
    100% {
        flex: 1;
    }
}
.step1.step2 .device-content .title {
    opacity: 1;
    transform: scale(1) translateY(-50%);
}
.step1.step2 .device-content .device {
    opacity: 0.6;
}
.step1.step2 .device-content .device--left {
    left: 50%;
}
.step1.step2 .device-content .device--right {
    right: 50%;
}
.step1.step2 .line {
    opacity: 1;
    margin-right: 0;
}
.step1.step2 .line .circle {
    opacity: 1;
    transform: rotate(0) translate(-50%, -50%);
}

.step1.step3 .line .circle {
    opacity: 0;
}

.step1.step3 .device-content .device {
    opacity: 0;
    transition: 0.3s;
}
.step1.step3 .device-content .title {
    transform: scale(0.7);
    top: 85px;
    transition-delay: 0.3s;
}

.step1.last-step .device-content--right {
    animation: device-content-reverse 0.3s forwards;
}
@keyframes device-content-reverse {
    0% {
        flex: 1;
    }
    100% {
        flex: 0;
    }
}
.step1.last-step .line {
    opacity: 0;
    margin-right: -10px;
}
.step1.last-step .device-content .title {
    opacity: 0;
}
.step1.last-step .device-content > div {
    opacity: 0 !important;
    transition-delay: 0s !important;
}
.step1.last-step .logo-versus {
    opacity: 0;
}
.step1.last-step .last-step-content {
    opacity: 1 !important;
}
.step1.last-step .last-step-content div {
    opacity: 1;
}

.bar span {
    transition: all 3s ease-out;
    width: 0px;
}

.RadarChart__missing___1NNQY {
    text-align: center;
}

 {
    width: 100%;
    height: 100%;
    text-align: center;
}

svg {
    overflow: visible !important;
}

.RadarChart__shape___2y0ze {
    fill-opacity: 0.75;
}

.RadarChart__scale___2QRZA {
    fill: #fafafa;
    stroke: #999;
    stroke-width: 0.2;
}

.RadarChart__axis___bhp3g {
    stroke: #555;
    stroke-width: 0.2;
}

.RadarChart__dot___3qU_p {
    fill: #fff;
    stroke: #e7e8e7;
    r: 3;
    transition: r 0.2s;
}

.RadarChart__dot___3qU_p:hover {
    stroke: #bbb;
    r: 7;
}

.RadarChart__captions___1luhL {
    font-size: 12px;
    fill: #616161;
    text-transform: uppercase;
    cursor: pointer;
}

.RadarChart__captions___1luhL.RadarChart__selected___23ak1 {
    font-weight: 700;
    fill: #161616;
}

@media (min-width: 641px) {
    .RadarChart__captions___1luhL:hover {
        text-decoration: underline;
    }
}

@media (max-width: 641px) {
    .RadarChart__captions___1luhL {
        font-size: 12px;
    }
}

.RadarChart__tooltip___2LhuH {
    position: absolute;
    -webkit-transform: translate(-50%, -130%);
    transform: translate(-50%, -130%);
    background-color: #333;
    color: #fff;
    padding: 5px 10px;
    border-radius: 2px;
}

.RadarChart__tooltip___2LhuH span {
    display: block;
}

.RadarChart__dotName___1vojt {
    font-size: 10px;
}

.RadarChart__points___3Szrl {
    font-size: 28px;
}

.RadarChart__pointsText___38PEu {
    text-transform: capitalize;
    font-size: 10px;
}

.RadarChart__legend___3PWG1 {
    display: flex;
    justify-content: space-evenly;
    margin-top: 30px;
    margin-bottom: 25px;
}

.RadarChart__legend___3PWG1.RadarChart__moreThanTwo___1TzPw {
    flex-direction: column;
    justify-content: flex-start;
}

.RadarChart__legend___3PWG1.RadarChart__moreThanTwo___1TzPw .RadarChart__legendObject___1BV6K {
    margin-top: 8px;
    text-align: left;
}

.RadarChart__legend___3PWG1.RadarChart__moreThanTwo___1TzPw .RadarChart__legendObject___1BV6K:first-child {
    margin-top: 0;
}

@media (max-width: 1025px) {
    .RadarChart__legend___3PWG1 {
        width: 80%;
        margin: 30px auto 40px;
        flex-direction: column;
    }
}

@media (max-width: 641px) {
    .RadarChart__legend___3PWG1 {
        display: none;
    }
}

.RadarChart__legend___3PWG1 .RadarChart__legendObject___1BV6K:first-child .RadarChart__name___1c6uG:before {
    background: linear-gradient(134deg, #3c59fc, #7600e0);
}

.RadarChart__legend___3PWG1 .RadarChart__legendObject___1BV6K:nth-child(2) .RadarChart__name___1c6uG:before {
    background: linear-gradient(134deg, #ff5631, #ff164b);
}

.RadarChart__legend___3PWG1 .RadarChart__legendObject___1BV6K:nth-child(3) .RadarChart__name___1c6uG:before {
    background: linear-gradient(134deg, #c5e626, #40e627);
}

.RadarChart__legend___3PWG1 .RadarChart__legendObject___1BV6K:nth-child(4) .RadarChart__name___1c6uG:before {
    background: linear-gradient(134deg, #ffcd00, #ff5631);
}

.RadarChart__legend___3PWG1 .RadarChart__legendObject___1BV6K:nth-child(5) .RadarChart__name___1c6uG:before {
    background: linear-gradient(134deg, #00feb0, #39c3e0);
}

.RadarChart__legend___3PWG1 .RadarChart__legendObject___1BV6K:nth-child(6) .RadarChart__name___1c6uG:before {
    background: linear-gradient(134deg, #ff2de0, #7600e0);
}

.RadarChart__legend___3PWG1 .RadarChart__legendObject___1BV6K:nth-child(7) .RadarChart__name___1c6uG:before {
    background: linear-gradient(134deg, #39c3e0, #3c59fc);
}

@media (max-width: 1025px) {
    .RadarChart__legend___3PWG1 .RadarChart__legendObject___1BV6K {
        margin-top: 8px;
    }
    .RadarChart__legend___3PWG1 .RadarChart__legendObject___1BV6K:first-child {
        margin-top: 0;
    }
}

.RadarChart__legend___3PWG1 .RadarChart__name___1c6uG {
    position: relative;
    font-size: 16px;
    color: #313131;
    padding-left: 25px;
}

.RadarChart__legend___3PWG1 .RadarChart__name___1c6uG:before {
    content: "";
    position: absolute;
    left: 0;
    width: 20px;
    height: 20px;
    border-radius: 2px;
}

.RadarChart__groupButtons___1k3zq {
    display: flex;
    justify-content: center;
    margin-bottom: 1em;
}

.RadarChart__groupButtons___1k3zq .RadarChart__groupButton___1jVh8 {
    position: relative;
    display: flex;
    justify-content: center;
    width: 36px;
    height: 34px;
    box-sizing: border-box;
    background-color: #f4f4f4;
    border: 1px solid #ddd;
    border-top: none;
    border-bottom: 2px solid #888;
    border-radius: 5px;
    margin: 0 5px;
    padding-top: 4px;
    cursor: pointer;
}

.RadarChart__groupButtons___1k3zq .RadarChart__groupButton___1jVh8:hover {
    background-color: #dfdfdf;
}

.RadarChart__groupButtons___1k3zq .RadarChart__groupButton___1jVh8:hover .RadarChart__tip___2izHT {
    display: block;
}

.RadarChart__groupButtons___1k3zq .RadarChart__groupButton___1jVh8.RadarChart__selected___23ak1 {
    background: linear-gradient(134deg, #3c59fc, #7600e0);
}

.RadarChart__pointsContainer___34AsW {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin-bottom: 30px;
}

.RadarChart__pointsContainer___34AsW .RadarChart__rivalValue___3w6RE {
    position: relative;
    border-right: 1px solid #dfdfdf;
    padding: 0 20px;
    margin-top: 6px;
    cursor: pointer;
}

.RadarChart__pointsContainer___34AsW .RadarChart__rivalValue___3w6RE:last-child {
    border: none;
}

.RadarChart__pointsContainer___34AsW .RadarChart__rivalValue___3w6RE:first-child .RadarChart__value___Ootfo {
    color: red;
}

.RadarChart__pointsContainer___34AsW .RadarChart__rivalValue___3w6RE:nth-child(2) .RadarChart__value___Ootfo {
    color: #ff5631;
}

.RadarChart__pointsContainer___34AsW .RadarChart__rivalValue___3w6RE:nth-child(3) .RadarChart__value___Ootfo {
    color: #c5e626;
}

.RadarChart__pointsContainer___34AsW .RadarChart__rivalValue___3w6RE:nth-child(4) .RadarChart__value___Ootfo {
    color: #ffcd00;
}

.RadarChart__pointsContainer___34AsW .RadarChart__rivalValue___3w6RE:nth-child(5) .RadarChart__value___Ootfo {
    color: #00feb0;
}

.RadarChart__pointsContainer___34AsW .RadarChart__rivalValue___3w6RE:nth-child(6) .RadarChart__value___Ootfo {
    color: #ff2de0;
}

.RadarChart__pointsContainer___34AsW .RadarChart__rivalValue___3w6RE:nth-child(7) .RadarChart__value___Ootfo {
    color: #39c3e0;
}

.RadarChart__pointsContainer___34AsW .RadarChart__rivalValue___3w6RE:hover .RadarChart__tip___2izHT {
    display: block;
}

.RadarChart__pointsContainer___34AsW .RadarChart__value___Ootfo {
    font-size: 1.5em;
    font-weight: 700;
}

.RadarChart__pointsContainer___34AsW .RadarChart__pointsLabel___2bhme {
    color: #bebebe;
    text-transform: capitalize;
}

.RadarChart__tip___2izHT {
    position: absolute;
    display: none;
    top: -10px;
    left: 50%;
    -webkit-transform: translate(-50%, -100%);
    transform: translate(-50%, -100%);
    background-color: #161616;
    font-size: 14px;
    color: #fff;
    padding: 5px 10px;
    border-radius: 2px;
}

.RadarChart__tip___2izHT:after {
    position: absolute;
    content: "";
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border: 5px solid transparent;
    border-top-color: #161616;
}

.RadarChart__captions___1luhL {
    filter: url(#caption);
}

.svg-container {
    position: fixed !important;
    top: 100px !important;
    left: 0 !important;
    width: 1920px;
    height: 1080px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99;
}
.svg-container svg {
    width: 850px !important;
    height: 850px !important;
}

.bars__points {
    background: white;
    border-radius: 1000px;
    width: 250px;
    height: 250px;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-shadow: 0 0 0 transparent !important;
}

.bars--widget {
    display: flex;
    flex-direction: column;
    text-align: center;

    justify-content: center;
}

.device-content--right .bars--widget {
    display: flex;
    align-items: flex-end;
}

.bars__winner {
    width: 380px;
    display: block;
    box-sizing: border-box;
    background: -webkit-linear-gradient(45deg, #ffcd00, #ff5631);
    padding: 30px 15px;
    text-align: center;
    font-weight: bold;
    font-size: 60px;
    border-radius: 999px;
    color: white;
    position: absolute;
    top: 1150px;
    left: 0;
}
.device-content--right .bars__winner {
    right: 0;
    left: initial;
}

.device-content--winner .bars__winner.active {
    animation: jackInTheBox 1.5s forwards;
    animation-delay: 3s;
    display: block;
    opacity: 0;
}

@keyframes jackInTheBox {
    from {
        opacity: 0;
        transform: scale(0.1) rotate(30deg);
        transform-origin: center bottom;
    }

    50% {
        transform: rotate(-10deg);
    }

    70% {
        transform: rotate(3deg);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

    .svg-container [fill~="#3c59fc"] {
        fill: #39C3E0;
    }

    .svg-container [stroke~="#3c59fc"] {
        stroke: #327c97;
    }

    .svg-container [fill~="#ff5631"] {
        fill: #FFCD00;
    }
    .svg-container [stroke~="#ff5631"] {
        stroke: #bf9a00;
    }
</style>

